import type { RouteRecordRaw } from 'vue-router';

export const geneRoutes: Array<RouteRecordRaw> = [
  {
    path: '/gene',
    name: 'gene',
    redirect: '/gene/person/list',
    component: () => import('pages/info/gene/person/GenePerson.vue'),
    meta: {
      title: 'Persons',
      requiresAuth: true,
    },
    children: [],
  },
  {
    path: '/gene/person',
    name: 'genePerson',
    redirect: '/gene/person/list',
    component: () => import('pages/info/gene/person/GenePerson.vue'),
    meta: {
      title: 'Persons',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'genePersonList',
        component: () => import('pages/info/gene/person/PersonList.vue'),
        meta: {
          title: 'Persons List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'genePersonDetail',
        component: () => import('pages/info/gene/person/PersonDetail.vue'),
        meta: {
          title: 'Person Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'genePersonNew',
        component: () => import('pages/info/gene/person/PersonNew.vue'),
        meta: {
          title: 'New Person',
          requiresAuth: true,
        },
      },
      {
        path: 'explorer',
        name: 'genePersonExplorer',
        component: () => import('pages/info/gene/person/PersonExplorer.vue'),
        meta: {
          title: 'Genealogy Explorer',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/gene/asset',
    name: 'geneAsset',
    redirect: '/gene/asset/list',
    component: () => import('pages/info/gene/asset/GeneAsset.vue'),
    meta: {
      title: 'Assets',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'geneAssetList',
        component: () => import('pages/info/gene/asset/AssetList.vue'),
        meta: {
          title: 'Assets List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'geneAssetDetail',
        component: () => import('pages/info/gene/asset/AssetDetail.vue'),
        meta: {
          title: 'Asset Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'geneAssetNew',
        component: () => import('pages/info/gene/asset/AssetNew.vue'),
        meta: {
          title: 'New Asset',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/gene/relation',
    name: 'geneRelation',
    redirect: '/gene/relation/list',
    component: () => import('pages/info/gene/relation/GeneRelation.vue'),
    meta: {
      title: 'Relations',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'geneRelationList',
        component: () => import('pages/info/gene/relation/RelationList.vue'),
        meta: {
          title: 'Relations List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'geneRelationDetail',
        component: () => import('pages/info/gene/relation/RelationDetail.vue'),
        meta: {
          title: 'Relation Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'geneRelationNew',
        component: () => import('pages/info/gene/relation/RelationNew.vue'),
        meta: {
          title: 'New Relation',
          requiresAuth: true,
        },
      },
      {
        path: 'explorer',
        name: 'geneRelationExplorer',
        component: () => import('pages/info/gene/relation/RelationExplorer.vue'),
        meta: {
          title: 'Genealogy [Relations] Explorer',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/gene/event',
    name: 'geneEvent',
    redirect: '/gene/event/list',
    component: () => import('pages/info/gene/event/GeneEvent.vue'),
    meta: {
      title: 'Events',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'geneEventList',
        component: () => import('pages/info/gene/event/EventList.vue'),
        meta: {
          title: 'Events List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'geneEventDetail',
        component: () => import('pages/info/gene/event/EventDetail.vue'),
        meta: {
          title: 'Event Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'geneEventNew',
        component: () => import('pages/info/gene/event/EventNew.vue'),
        meta: {
          title: 'New Event',
          requiresAuth: true,
        },
      },
      {
        path: 'explorer',
        name: 'geneEventExplorer',
        component: () => import('pages/info/gene/event/EventExplorer.vue'),
        meta: {
          title: 'Historical Events Explorer',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/gene/event/role',
    name: 'geneEventRole',
    redirect: '/gene/event/role/list',
    component: () => import('pages/info/gene/eventRole/EventRole.vue'),
    meta: {
      title: 'Event Roles',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'geneEventRoleList',
        component: () => import('pages/info/gene/eventRole/EventRoleList.vue'),
        meta: {
          title: 'Event Roles List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'geneEventRoleDetail',
        component: () => import('pages/info/gene/eventRole/EventRoleDetail.vue'),
        meta: {
          title: 'Event Role Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'geneEventRoleNew',
        component: () => import('pages/info/gene/eventRole/EventRoleNew.vue'),
        meta: {
          title: 'New Event Role',
          requiresAuth: true,
        },
      },
    ],
  },
];
